import { toast } from "react-toastify";

export const showSuccess = (message) => {
  toast.success(message || "Operation completed successfully", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
  });
};

export const showError = (message) => {
  toast.error(message || "Something went wrong", {
    position: "top-right",
    autoClose: 4000,
  });
};

export const showInfo = (message) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 3000,
  });
};